<template>
  <div v-if="!creatingCard">
    <div class="z-title z-title--small spacer-bottom-l">
      {{ title }}
    </div>

    <card-list
      :cards="cards"
      @cardSelected="cardSelected"
      @cardRemoved="loadCards"
    />

    <button
      class="z-button z-button--secondary z-button--block"
      @click="creatingCard = !creatingCard"
    >
      Cadastrar um novo cartão
    </button>
  </div>

  <div v-else class="spacer-top-j">
    <div class="z-title z-title--small spacer-bottom-l">
      {{ titleForm }}
    </div>

    <card-form
      :card-type="cardType"
      @cardCreated="loadCards"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import CardForm from 'components/card-form';
import CardList from 'components/card-list';

export default {
  components: {
    CardForm,
    CardList,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    titleForm: {
      type: String,
      required: false,
      default: '',
    },
    cardType: {
      type: String,
      required: true,
      validator: (cardType) => cardType === 'credit_card',
    },
  },
  data() {
    return {
      creatingCard: false,
    };
  },
  computed: {
    ...mapState(['studentCards']),
    cards() {
      return this.studentCards.filter((card) => card.card_type === this.cardType);
    },
  },
  methods: {
    cardSelected(card) {
      this.$emit('cardSelected', card);
    },
    loadCards() {
      this.loadStudentCards().then(() => {
        if (!this.cards.length) {
          this.creatingCard = true;
        } else {
          this.creatingCard = false;
        }
      });
    },
    ...mapActions(['loadStudentCards']),
  },
  created() {
    this.loadCards();
  },
};
</script>
